/**
 * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
 * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
 *
 * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
 */

export const disableNavReasons = {
    securityOverlay: 'securityOverlay', // when a security overlay shows
    pciControlsNav: 'pciControlsNav', // when EntryCode or other PCI says so
    proctorWait: 'proctorWait', // when waiting for the proctor
    pendingOps: 'pendingOps', // when there are pending operations (typically at item-runner level, e.g. file uploads)
    guidedNav: 'guidedNav', // when forward navigation is guided by timers (item min timer == item max timer) or authored sequence-ended items
    overlay: 'overlay', // when another type of overlay shows
    moving: 'moving', // when item is unloaded for navigation
    timeoutAutoNav: 'timeoutAutoNav' // on timeout, when auto-navigate feature is preparing for the navigation
};
